<template>
  <div class="live-edit" @click="textClicked" @keypress.enter="finalize" @focusout="finalize">

    <el-input
      v-if="isEditing"
      v-model="modelvalue"
      :autofocus="true"
      :placeholder="placeholder"
      v-focus
      @blur="finalize"/>

    <span v-else>{{modelvalue || placeholder}}</span>

  </div>
</template>

<script>
export default {
  name: 'LiveEdit',
  props: {
    value: {
      type: [String, Object],
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String
    }
  },
  data () {
    return {
      modelvalue: this.value,
      isEditing: false
    }
  },
  methods: {
    textClicked () {
      if (this.editable) {
        this.isEditing = true
      }
    },
    finalize () {
      this.isEditing = false
    }
  },
  watch: {
    modelvalue (val) {
      this.$emit('input', val)
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.getElementsByTagName('input')[0].focus()
      }
    }
  }
}
</script>

<style lang="scss">
.live-edit{
  input {
    height: 25px !important;
    padding-left: 3px;
    margin-top: -2px;
  }
  .el-input, .el-input__inner {
    width: 60%;
  }
}
</style>


// WEBPACK FOOTER //
// LiveEdit.vue?49e1dd42